import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import NewElementObject from './NewElementObject'
import LayoutHolder from './LayoutHolder'
import BlockHolder from './BlockHolder'
import CustomBlocksEmptyState from './BlockHolder/CustomBlocksEmptyState'
import { fetchTier } from '~/data/actions/accountActions'
import AppHolder from './AppHolder'

const ElementPicker = ({
    type,
    components,
    insertElement,
    updateBlocks,
    showUpsell,
    userApps,
    isForm = false,
    isLandingPage = false,
    templateJson = {}
}) => {
    const dispatch = useDispatch()
    const [showMoreLayouts, setShowMoreLayouts] = useState(false)

    const handleInsert = (theEl) => {
        insertElement(theEl.content)
    }

    const handleUpgrade = () => {
        dispatch(fetchTier())
    }

    const renderItem = (thisEl, index, Component, elementPrefix) => {
        if (thisEl.hidden) {
            return null
        }

        const dataPhSlug = (thisEl.title || '')
            .toString()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '')

        let outerHolderClass = 'dndEditorv2-leftToolsElementPicker-elementHolder lElementHolder'

        let disabled = false
        let disabledExplainer = ''
        if (thisEl.onlyAllowOneInstance) {
            //make sure its not already in use on the stage
            function findElementByIdAndName(id, name, json) {
                if (json.elements && json.elements.length > 0) {
                    for (const element of json.elements) {
                        if (findElementByIdAndName(id, name, element)) return true
                    }
                }
                if (json.ComponentId + '' === id + '' && json.name + '' === name + '') {
                    disabled = true
                    disabledExplainer = thisEl.onlyAllowOneInstanceExplainer || ''
                    return
                }
            }
            findElementByIdAndName(thisEl.content.ComponentId, thisEl.content.name, templateJson)
        }

        return (
            <div
                key={`${elementPrefix}${index}`}
                className={outerHolderClass}
                data-ph={`dragdrop-${type}-${dataPhSlug}`}
                onClick={() => {
                    if (disabled) return
                    handleInsert(thisEl)
                }}
            >
                <Component
                    id={`${elementPrefix}${index}`}
                    title={thisEl.label || thisEl.title}
                    content={thisEl.content}
                    toolbarIcon={thisEl.toolbarIcon || null}
                    icon={thisEl.icon || null}
                    element={thisEl}
                    app={thisEl}
                    blockId={thisEl.componentId}
                    updateBlocks={updateBlocks}
                    type={type}
                    userApps={userApps}
                    disabled={disabled}
                    disabledExplainer={disabledExplainer}
                />
            </div>
        )
    }

    if (type === 'element') {
        const elements = components.filter((theC) => !theC.marketPlace || theC.marketPlace === 0)
        let outerClass = 'dndEditorv2-leftToolsElementPicker-holder'
        if (isForm) {
            outerClass += ' dndEditorv2-leftToolsElementPicker-holder--2col'
        }
        return (
            <div className={outerClass}>
                {elements.map((thisEl, index) =>
                    thisEl.category === 'element' ? renderItem(thisEl, index, NewElementObject, 'newEl-') : null
                )}
            </div>
        )
    }

    if (type === 'layout') {
        return (
            <>
                <div className='dndEditorv2-leftToolsElementPicker-layoutEdition-holder'>
                    {components.map((thisEl, index) => renderItem(thisEl, index, LayoutHolder, 'newLay-'))}
                </div>
            </>
        )
    }

    if (type === 'block') {
        return (
            <div className='dndEditorv2-leftToolsElementPicker-holder'>
                {components.map((thisEl, index) => renderItem(thisEl, index, BlockHolder, 'newLay-block-'))}
            </div>
        )
    }

    if (type === 'userBlock') {
        if (!components || !components.length || showUpsell) {
            return (
                <CustomBlocksEmptyState
                    showUpsell={showUpsell}
                    isForm={isForm}
                    isLandingPage={isLandingPage}
                    onUpgrade={handleUpgrade}
                />
            )
        }
        return (
            <div className='dndEditorv2-leftToolsElementPicker-holder dndEditorv2-leftToolsElementPicker-holder--layouts'>
                {components.map((thisEl, index) => renderItem(thisEl, index, BlockHolder, 'newLay-user-'))}
            </div>
        )
    }

    if (type === 'app') {
        return (
            <div className='dndEditorv2-leftToolsElementPicker-holder dndEditorv2-leftToolsElementPicker-holder--apps'>
                {components.map((thisEl, index) => renderItem(thisEl, index, AppHolder, 'marketApp-'))}
            </div>
        )
    }

    return <div></div>
}

export default ElementPicker
